import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdBuilderOptions } from '@onefootprint/fetch-dashboard';
import type { AgentNode, AgentNodeDecision } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
const isDecision = (node: AgentNode): node is AgentNodeDecision => node.kind === 'decision';

// The decision node behind a decision-result artifact, read from the run's exact agent version.
const useAgentDecisionNode = t0 => {
  const $ = _c(13);
  const {
    agentId,
    versionId,
    nodeId
  } = t0;
  let t1;
  if ($[0] !== agentId || $[1] !== versionId) {
    t1 = getOrgAgentsByAgentIdBuilderOptions({
      path: {
        agentId
      },
      query: {
        versionId
      }
    });
    $[0] = agentId;
    $[1] = versionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = Boolean(agentId && versionId && nodeId);
  let t3;
  if ($[3] !== nodeId) {
    t3 = response => response.graph.nodes.filter(isDecision).find(node => node.id === nodeId) ?? null;
    $[3] = nodeId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      ...t1,
      enabled: t2,
      select: t3
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const query = useQuery(t4);
  const t5 = query.data ?? null;
  let t6;
  if ($[9] !== query.error || $[10] !== query.isLoading || $[11] !== t5) {
    t6 = {
      node: t5,
      isPending: query.isLoading,
      error: query.error
    };
    $[9] = query.error;
    $[10] = query.isLoading;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default useAgentDecisionNode;